import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Fade,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import useReactRouter from "use-react-router";
import { scroller } from "react-scroll";
import { useReduxSelector } from "hooks";
import { Redirect } from "react-router-dom";
import { withPlanner, WithPlannerProps } from "components/hoc";
import { MouseParallax } from "react-just-parallax";
import { useStyles } from "./promo.style";
import { img } from "./assets";
import RulesSection from "./sections/rules";
import GallerySection from "./sections/gallery";
import PrizesSection from "./sections/prizes";
import WinnersSection from "./sections/winners";

const PromoPage: React.FC<WithPlannerProps> = withPlanner(({ planner }) => {
  const classes = useStyles();
  const { history } = useReactRouter();
  const { isAuth } = useReduxSelector((state) => state.auth);
  const { promoAviable } = useReduxSelector((state) => state.props);

  const lg = useMediaQuery(({ breakpoints: { down } }: Theme) => down("md"));
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down("sm"));
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down("xs"));

  const [pvar, setPvar] = useState<number>(0);

  const handleClick = () => {
    if (isAuth) history.push({ pathname: "profile", hash: "contest" });
    else history.push({ search: "signin" });
  };

  useEffect(() => {
    if (history.location.hash === "#contest_rules") {
      planner?.timeout(() => {
        scroller.scrollTo("contest_rules", {
          ignoreCancelEvents: true,
          activeClass: "active",
          duration: 700,
          hashSpy: true,
          smooth: true,
          offset: 0,
          spy: true,
        });
        history.push({ hash: "" });
      }, 150);
    }
  }, [history.location]);

  if (typeof promoAviable === "undefined")
    return (
      <Box my={4} textAlign="center">
        <CircularProgress />
      </Box>
    );

  if (promoAviable === false) {
    return <Redirect to={{ pathname: "/" }} />;
  }
  return (
    <Fade in timeout={350}>
      <Box className={classes.root}>
        <Box className={classes.top}>
          <img
            src={img.bg}
            style={{ visibility: "hidden", width: "100%" }}
            alt=""
          />
          {!md && (
            <Box className={classes.bg}>
              <MouseParallax lerpEase={0.02}>
                <Box className={classes.bg}>
                  <img src={img.lt} alt="" />
                </Box>
              </MouseParallax>
              <MouseParallax lerpEase={0.04}>
                <Box className={classes.bg}>
                  <img src={'/imgs/promo4/t.png'} alt="" />
                </Box>
              </MouseParallax>
              <MouseParallax lerpEase={0.012}>
                <Box className={classes.bg}>
                  <img src={img.lb} alt="" />
                </Box>
              </MouseParallax>
            </Box>
          )}

          <Container
            maxWidth={false}
            style={{
              maxWidth: "100%",
              position: "absolute",
              top: 0,
              height: "100%",
              zIndex: 1,
            }}
          >
            <Grid
              container
              justifyContent={"flex-end"}
              alignItems="center"
              style={{ height: "100%", animationDelay: "0.1s" }}
              className={`animated ${md ? "fadeIn" : "fadeIn"} faster`}
            >
              <Grid item xs={12} md={6}>
                <Box pb={2} px={{ xs: 2, md: 0 }}>
                  <Typography
                    style={{
                      textAlign: "center",
                      lineHeight: 1.2,
                      color: "#fff",
                      userSelect: "none",
                      fontSize: !sm ? "3vw" : "2vh",
                    }}
                    variant="h1"
                  >
                    {md && (
                      <Box textAlign={"center"}>
                        <img
                          src={img.txs}
                          alt=""
                          style={{ maxWidth: "100%", margin:"auto" }}
                        />
                      </Box>
                    )}
                    Зима - пора
                    <br />
                    новогодних чудес!
                  </Typography>
                </Box>
                <Box textAlign={"center"} mt={2} mb={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClick}
                  >
                    участвовать в конкурсе
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>

        <Box className={classes.body}>
          {/*<Suspense fallback="">*/}
          <RulesSection />
          <GallerySection />
          <PrizesSection />
          <WinnersSection />
          {/*</Suspense>*/}
        </Box>
      </Box>
    </Fade>
  );
});

export default PromoPage;
